import React from 'react';
import { Link } from 'react-router';
import { DeleteDialog } from 'modules/dialog';
import { CheckPermission } from 'modules/login/CheckPermission';

export default class RowItemDoiTuongThanhTra extends React.Component {
  onSelectedDoiTuong(e) {
    this.props.parent.handleSelectedDoiTuong(e, this.props.item)
  }

  render() {
    return (
      <tr>
        {this.props.isTTTP && (
        <td className='table-checkbox'>
          <label className="pt-control pt-checkbox pt-large">
            <input
              type="checkbox"
              disabled={this.props.item.approved}
              checked={this.props.doiTuongSelecteds.includes(this.props.item.doiTuongThanhTraId) && !this.props.item.approved}
              className="pt-large"
              onChange={this.onSelectedDoiTuong.bind(this)}
              name="checkboxKetQua"
            />
            <span className="pt-control-indicator"></span>
          </label>
        </td>
        )}
        <td>
          {this.props.count}
        </td>
        <td>
          {this.props.item.ma}
        </td>
        <td>
          {this.props.item.ten}
        </td>
        <td>
          {this.props.item.loaiDoiTuongThanhTraInfo ? this.props.item.loaiDoiTuongThanhTraInfo.text : ''}
        </td>
        <td>
          {this.props.item.diaChi}
        </td>
        <td>
          {this.props.item.soDienThoai}
        </td>
        <td>
          {this.props.item.approved ? 'Đã duyệt' : 'Chưa duyệt'}
        </td>
        <td>
          {this.props.item.ghiChu}
        </td>
        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('DOITUONGTHANHTRA_SUA') ?
                <Link
                  className="itt-edit"
                  onClick={this.props.parent.openUpdateCategory.bind(this.props.parent, this.props.item)}
                >
                  Chỉnh sửa
                </Link>
                : null
            }
            {
              CheckPermission('DOITUONGTHANHTRA_XOA') ?
                <DeleteDialog
                  title={'Xoá danh mục'}
                  content={'Bạn chắc chắn muốn xoá danh mục này?'}
                  redux={this.props.parent}
                  deleteId={this.props.item.doiTuongThanhTraId}
                />
                : null
            }
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/category/datatable/list/RowItemDoiTuongThanhTra.jsx